'use client';
import { useEffect, useState } from 'react';
import styles from './myAdsDetail.module.scss';
import { COLORS } from 'utilities';
import { useParams } from 'react-router-dom';
import { API, PATH } from 'data';
import { Empty, message, Spin } from 'antd';
import { MobileHeaderComp } from 'components';
import { Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import ToolsCardComp from './toolCard/toolCard.index';
import {
    TbChartBar,
    TbClipboardCheck,
    TbClockCheck,
    TbCreditCard,
    TbEdit,
    TbEscalatorUp,
    TbEye,
    TbTrash,
} from 'react-icons/tb';
import {
    APPlicationStoreEnum,
    ApprovalStatusEnum,
    PaginationType,
    PaymentStatusEnum,
    PaymentTypeEnum,
    PostType,
    ViewType,
} from 'types';
import PostDetailStatusComp from './status/status.index';
import { __DateDifference, __GeneratePostViewPlot } from './myAdsDetail.script';
import { AppStorage, RestAPI, useBP } from 'scripts';
import PostDeleteComp from './delete/delete.index';
import RenewPaymentComp from './renewPayment/renewPayment.index';

function MyAdsDetailComp() {
    const [open, setOpen] = useState(false);
    const [showStatistics, setShowStatistics] = useState(false);
    const { slug } = useParams();
    const [data, setData] = useState<PostType<'detail'>>();
    const [renew, setRenew] = useState<PostType<'detail'>>();
    const [views, setViews] = useState<ViewType[]>();
    const plotData = __GeneratePostViewPlot(views);
    const bp = useBP();

    useEffect(() => {
        if (slug)
            RestAPI.get<PostType<'detail'>>(API.posts.myPostDetail(slug)).then((res) => {
                setData(res.data);
                RestAPI.get<PaginationType<ViewType>>(API.view.myPost, { post: res.data.id, page_size: 100 }).then(
                    (res) => setViews(res.data.data),
                );
            });
    }, []);

    const onPaymentHandler = () => {
        const key = 'loading' + new Date().getTime();
        message.open({
            key,
            type: 'loading',
            content: 'در حال ورود به درگاه پرداخت',
        });
        console.log('AppStorage.applicationStore.get()', AppStorage.applicationStore.get());
        if (AppStorage.applicationStore.get() === APPlicationStoreEnum.cafebazar) {
            RestAPI.post<{ payment_url: string }>(API.payment.bazarPay, {
                type: PaymentTypeEnum.create,
                post: data?.id,
            })
                .then((res) => (window.location.href = res.data.payment_url))
                .catch(() => {
                    message.open({
                        key,
                        type: 'error',
                        content: 'ورود به درگاه پرداخت با خطا مواجه شد. لطفا بعدا تلاش کنید',
                    });
                });
        } else {
            RestAPI.post<{ url: string }>(API.payment.pay, { type: PaymentTypeEnum.create, post: data?.id })
                .then((res) => (window.location.href = res.data.url))
                .catch(() => {
                    message.open({
                        key,
                        type: 'error',
                        content: 'ورود به درگاه پرداخت با خطا مواجه شد. لطفا بعدا تلاش کنید',
                    });
                });
        }
    };

    if (!data)
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin />
            </div>
        );

    return (
        <div className={`${styles['detail-layout']}`}>
            <MobileHeaderComp
                title={showStatistics ? 'آمار آگهی' : 'مدیریت آگهی'}
                onIconClick={showStatistics ? () => setShowStatistics(false) : undefined}
                backPath={PATH.panel.myAds.index()}
            />
            <h3 className="mb-2">{data.title}</h3>
            <PostDetailStatusComp
                status={data.approval_status}
                rejectReason={data.reject_reason}
                paymentStatus={data.payment_status}
            />
            <div className={`${styles['tools-layout']} g-3 mb-4 ${showStatistics ? 'd-pre-md-none-i' : ''}`}>
                <ToolsCardComp
                    className="d-none-i"
                    icon={<TbClockCheck size={20} className="t-black1 t-d-gray1" />}
                    text={__DateDifference({ dateString: data.created_at })}
                    title="انقضا آگهی"
                    noAction
                />
                {data.payment_status !== PaymentStatusEnum.success ? (
                    <ToolsCardComp
                        icon={<TbCreditCard size={20} className="t-black1 t-d-gray1" />}
                        title="پرداخت و انتشار"
                        onClick={() => onPaymentHandler()}
                    />
                ) : null}
                {data.approval_status === ApprovalStatusEnum.approved ? (
                    <ToolsCardComp
                        icon={<TbEscalatorUp size={20} className="t-black1 t-d-gray1" />}
                        title="نردبان آگهی"
                        onClick={() => setRenew(data)}
                    />
                ) : null}
                {data.approval_status !== ApprovalStatusEnum.rejected ? (
                    <ToolsCardComp
                        icon={<TbEye size={20} className="t-black1 t-d-gray1" />}
                        title={data.approval_status === ApprovalStatusEnum.pending ? 'پیش نمایش آگهی' : 'مشاهده آگهی'}
                        href={PATH.postDetail(data.slug)}
                        navigate={bp?.MD_LTE ? false : true}
                        nextLink={bp?.MD_LTE ? true : false}
                    />
                ) : null}
                <ToolsCardComp
                    icon={<TbChartBar size={20} className="t-black1 t-d-gray1" />}
                    title="آمار آگهی"
                    onClick={() => setShowStatistics(true)}
                    className="d-md-none"
                />
                <ToolsCardComp
                    icon={<TbEdit size={20} className="t-black1 t-d-gray1" />}
                    title="ویرایش آگهی"
                    href={PATH.panel.myAds.edit(data.slug)}
                />
                <ToolsCardComp
                    icon={<TbTrash size={20} className="t-black1 t-d-gray1" />}
                    title="حذف آگهی"
                    onClick={() => setOpen(true)}
                />
                <ToolsCardComp
                    icon={<TbClipboardCheck size={20} className="t-black1 t-d-gray1" />}
                    title="قوانین و مقررات"
                    href={PATH.terms}
                    navigate
                    className="d-md-none-i "
                />
            </div>
            <div className={`${styles['chart-layout']} ${showStatistics ? '' : 'd-pre-md-none'}`}>
                <div className="flex-between center-content-y mb-4 d-pre-md-none">
                    <h3 className="t-h3 t-l-black1 t-400">امار بازدید آگهی</h3>
                    <p className="t-p2 t-400 t-l-gray1">بازدید کل: {data.views_count} بازدید</p>
                </div>
                <div className="d-md-none justify-content-between align-items-center mb-5">
                    <p className="t-p2 t-400 t-l-gray1">بازدید کل:</p>
                    <p className="t-2 t-l-black1 t-400">{data.views_count} بازدید</p>
                </div>
                <div className={`${showStatistics ? 'pv-9' : ''}`}>
                    {plotData ? (
                        plotData.length ? (
                            <ResponsiveContainer height={230}>
                                <LineChart data={plotData} className="w-100">
                                    <Line type="monotone" dataKey="count" stroke={COLORS.primary} />
                                    <XAxis dataKey="date" />
                                    <YAxis />
                                </LineChart>
                            </ResponsiveContainer>
                        ) : (
                            <Empty
                                className="flex-column center-content"
                                description="بازدیدی برای آگهی شما ثبت نشده است."
                            />
                        )
                    ) : (
                        <div className={`w-100 pv-9 center-content flex-1`}>
                            <Spin />
                        </div>
                    )}
                </div>
            </div>
            <PostDeleteComp slug={data.slug} open={open} onClose={() => setOpen(false)} />
            <RenewPaymentComp post={renew} onClose={() => setRenew(undefined)} />
        </div>
    );
}

export default MyAdsDetailComp;
